module.exports = __webpack_public_path__ + "static/credit-application-efade20a7a889ff5e9f5298b8af34122.pdf";